var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{attrs:{"justify-md":"center"}},[_c('v-col',{attrs:{"cols":"4"}},[_c('v-card',{staticClass:"pa-6"},[_c('div',{staticClass:"primary--text text-center"},[_vm._v(" Logging Out ")]),_c('v-progress-linear',{staticClass:"mt-6",attrs:{"indeterminate":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }